import { actionTypes } from "../contants/actionTypes";

const initialState = {
    listAllDocs: [],
    isLoading: true,
    historyDoc: [],
    listDeatils: [],
    listConfiguration: [],
    columsTableDeatails: [],
    isLoadingDetails: true,
    rowsChecked: [],
    filters: {},
    pagination: {
        pageNumber: 1,
        pageSize: 50
    },
    counter: 0,
    id_user_action: null,
    id_company: null,
    select_company: false,
    table_check: false,
    hidde_action: false,
    rowsCheckedDetails: [],
    infoSudMenu: null,
}

export const sharedViewsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.isLoadingLoadAllDocs:
            return {
                ...state,
                isLoading: action.payload,
            }
        case actionTypes.loadAllDocs:
            return {
                ...state,
                listAllDocs: action.payload,
            }
        case actionTypes.loadHistory:
            return {
                ...state,
                historyDoc: action.payload,
            }
        case actionTypes.getListDetails:
            return {
                ...state,
                listDeatils: action.payload,
            }
        case actionTypes.getConfigurationTableDetails:
            return {
                ...state,
                listConfiguration: action.payload,
            }
        case actionTypes.getColumnsTableDetails:
            return {
                ...state,
                columsTableDeatails: action.payload,
            }
        case actionTypes.isLoadingListDetails:
            return {
                ...state,
                isLoadingDetails: action.payload,
            }
        case actionTypes.rowsChecked:
            return {
                ...state,
                rowsChecked: action.payload,
            }
        case actionTypes.filterAndPagination:
            return {
                ...state,
                filters: action.payload.filters,
                pagination: action.payload.pagination,
            }
        case actionTypes.counter:
            return {
                ...state,
                counter: action.payload,
            };
        case actionTypes.setIdUserAction:
            return {
                ...state,
                id_user_action: action.payload,
            };
        case actionTypes.setIdCompany:
            return {
                ...state,
                id_company: action.payload,
            };
        case actionTypes.isSelectCompany:
            return {
                ...state,
                select_company: action.payload,
            };
        case actionTypes.checkInTable:
            return {
                ...state,
                table_check: action.payload,
            }
        case actionTypes.visibleActions:
            return {
                ...state,
                hidde_action: action.payload,
            }
        case actionTypes.rowsCheckedDetails:
            return {
                ...state,
                rowsCheckedDetails: action.payload,
            }
        case actionTypes.infoSudMenu:
            return {
                ...state,
                infoSudMenu: action.payload,
            }
        case actionTypes.resetInitState:
            return initialState;
        default:
            return state;
    }
}